var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
          staticStyle: {
            "padding-bottom": "0 !important",
            "padding-top": "15px !important",
            height: "110px"
          }
        },
        [
          _c("div", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("APPLICATION MANAGER")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex m__t--42" }, [
            _c(
              "div",
              {
                staticClass: "tab-experience-manager m__r--35",
                class: {
                  "tab-experience-manager-active": _vm.tabSelected === "apps"
                },
                on: {
                  click: function($event) {
                    _vm.tabSelected = "apps"
                  }
                }
              },
              [_vm._v("\n        APPLICATION\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-experience-manager",
                class: {
                  "tab-experience-manager-active": _vm.tabSelected === "group"
                },
                on: {
                  click: function($event) {
                    _vm.tabSelected = "group"
                  }
                }
              },
              [_vm._v("\n        GROUP APPS\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "studio-page-content" },
        [
          _c(
            "v-client-table",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.load_first && _vm.tabSelected === "apps",
                  expression: "load_first && tabSelected === 'apps'"
                }
              ],
              staticClass: "jTable",
              attrs: {
                data: _vm.data_apps,
                columns: _vm.columns,
                options: _vm.table_options
              },
              scopedSlots: _vm._u([
                {
                  key: "id",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailApp(props.row.id_hash)
                          }
                        }
                      },
                      [_vm._v("\n        " + _vm._s(props.row.id) + "\n      ")]
                    )
                  }
                },
                {
                  key: "icon",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailApp(props.row.id_hash)
                          }
                        }
                      },
                      [
                        props.row.icon
                          ? _c("img", {
                              attrs: { src: props.row.icon, width: "32" }
                            })
                          : _vm._e()
                      ]
                    )
                  }
                },
                {
                  key: "name",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailApp(props.row.id_hash)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(props.row.name) + "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "is_offline_mode",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailApp(props.row.id_hash)
                          }
                        }
                      },
                      [
                        props.row.is_offline_mode
                          ? _c("div", { staticClass: "vp-on" }, [_vm._v("ON")])
                          : _c("div", { staticClass: "vp-off" }, [
                              _vm._v("OFF")
                            ])
                      ]
                    )
                  }
                },
                {
                  key: "total_page",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailApp(props.row.id_hash)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(props.row.total_page || 0) +
                            "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "created_at",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailApp(props.row.id_hash)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.convertDateTime(props.row.created_at)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "updated_at",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailApp(props.row.id_hash)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.convertDateTime(props.row.updated_at)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-search",
                  attrs: { slot: "beforeFilter" },
                  slot: "beforeFilter"
                },
                [
                  _c(
                    "b-form",
                    { attrs: { inline: "" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn grey btn-import-form m__r--5",
                          on: {
                            click: function($event) {
                              _vm.isModalAppTypeOpen(true)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus fa-lg" }),
                          _vm._v(" Add\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          attrs: { inline: "" },
                          on: {
                            keypress: function($event) {
                              if (
                                !("button" in $event) &&
                                $event.keyCode !== 13
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              _vm.filter(_vm.filter_data)
                            }
                          }
                        },
                        [
                          _c("j-select", {
                            staticClass: "m__r--5",
                            attrs: {
                              options: _vm.options_search,
                              placeholder: "Filter By"
                            },
                            model: {
                              value: _vm.select_type,
                              callback: function($$v) {
                                _vm.select_type = $$v
                              },
                              expression: "select_type"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-input", {
                            ref: "filterInputApp",
                            staticStyle: { width: "250px", height: "35px" },
                            attrs: { type: "text", placeholder: "Search" },
                            model: {
                              value: _vm.filter_data,
                              callback: function($$v) {
                                _vm.filter_data = $$v
                              },
                              expression: "filter_data"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          !_vm.load_first && _vm.tabSelected === "apps"
            ? _c("jLoadingTable")
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-client-table",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.load_first_group && _vm.tabSelected === "group",
                  expression: "load_first_group && tabSelected === 'group'"
                }
              ],
              staticClass: "jTable",
              attrs: {
                data: _vm.data_group_apps,
                columns: _vm.columns_group,
                options: _vm.table_options_group
              },
              scopedSlots: _vm._u([
                {
                  key: "id",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailGroup(props.row.id)
                          }
                        }
                      },
                      [_vm._v("\n        " + _vm._s(props.row.id) + "\n      ")]
                    )
                  }
                },
                {
                  key: "name",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailGroup(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(props.row.name) + "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "count_apps",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailGroup(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(props.row.count_apps || 0) +
                            "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "created_at",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailGroup(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.convertDateTime(props.row.created_at)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "updated_at",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.detailGroup(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.convertDateTime(props.row.updated_at)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-search",
                  attrs: { slot: "beforeFilter" },
                  slot: "beforeFilter"
                },
                [
                  _c(
                    "b-form",
                    { attrs: { inline: "" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn grey btn-import-form m__r--5",
                          on: {
                            click: function($event) {
                              _vm.isModalAppGroupOpen(true)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus fa-lg" }),
                          _vm._v(" Add\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          attrs: { inline: "" },
                          on: {
                            keypress: function($event) {
                              if (
                                !("button" in $event) &&
                                $event.keyCode !== 13
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              _vm.filterGroup(_vm.filter_data_group)
                            }
                          }
                        },
                        [
                          _c("j-select", {
                            staticClass: "m__r--5",
                            attrs: {
                              options: _vm.options_search_group,
                              placeholder: "Filter By"
                            },
                            model: {
                              value: _vm.select_type_group,
                              callback: function($$v) {
                                _vm.select_type_group = $$v
                              },
                              expression: "select_type_group"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-input", {
                            ref: "filterInputGroup",
                            staticStyle: { width: "250px", height: "35px" },
                            attrs: { placeholder: "Search" },
                            model: {
                              value: _vm.filter_data_group,
                              callback: function($$v) {
                                _vm.filter_data_group = $$v
                              },
                              expression: "filter_data_group"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          !_vm.load_first_group && _vm.tabSelected === "group"
            ? _c("jLoadingTable")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appTypeModal",
          staticClass: "mod-form modal-app-type",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("j-modal-app-type", {
            on: {
              "modal-open": _vm.isModalAppTypeOpen,
              "type-mode": _vm.typeMode
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appGroupModal",
          staticClass: "mod-form modal-app-type",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("j-modal-create-group", {
            on: { "modal-open": _vm.isModalAppGroupOpen }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73cf3501", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73cf3501","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/jApplicationSetting.vue
// module id = null
// module chunks = 